module.exports = __webpack_public_path__ + "static/media/t1.20b2740f.png";